import React from 'react'

const maxLength = (max: number) => (value: string) =>
	value && value.length > max ? `Must be ${max} characters or less` : undefined
const minLength = (min: number) => (value: string) =>
	value && value.length < min ? `Must be ${min} characters or more` : undefined
export const required = (value: string) => value ? undefined : 'Required'
export const maxLength1 = maxLength(1)
export const maxLength8 = maxLength(8)
export const maxLength10 = maxLength(10)
export const maxLength14 = maxLength(14)

export const maxLength100 = maxLength(100)

export const minLength6 = minLength(6)
export const minLength8 = minLength(8)

export const passwordsDiff = (value: string, allValues: any) =>
	value === allValues.oldPassword ? `Same as old password` : undefined
export const passwordsMatch = (value: string, allValues: any) =>
	value !== allValues.password ? `Passwords don't match` : undefined
export const newPasswordsMatch = (value: string, allValues: any) =>
	value !== allValues.newPassword ? `Passwords don't match` : undefined
export const isEmail = (value: string) =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
		'Invalid email address' : undefined

export const renderField = (params: any) => {
	let { input, label, type } = params
	let { asyncValidating, touched, error } = params.meta

	return (
		<div className={asyncValidating ? 'async-validating' : ''}>
			<input {...input} placeholder={label} type={type} />
			{touched && error && <span className='inputError'>{error}</span>}
			{
				(!touched || !error) && <span className='inputError'>&nbsp;</span>
			}
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/renderField.tsx